// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-base: #09090B;
  --bg-subtle: #27272A;
  --border-default: #3F3F46;

  --text-primary: #FAFAFA;
  --text-secondary: #A1A1AA;
  --text-muted: #71717A;

  --accent: #6366F1;
  --accent-hover: #818CF8;

  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.5);

  --font-display: 'Inter', system-ui, -apple-system, sans-serif;
  --font-mono: 'JetBrains Mono', ui-monospace, monospace;

  --text-sm: 0.875rem;
  --text-base: 1rem;
  --text-lg: 1.125rem;
  --text-xl: 1.25rem;

  --space-2: 8px;
  --space-4: 16px;
  --space-5: 20px;
  --space-6: 24px;
  --space-8: 32px;

  --radius-md: 8px;
}

*, *::before, *::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: var(--font-display);
  font-size: var(--text-base);
  color: var(--text-primary);
  background: var(--bg-base);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.5;
}

#root {
  min-height: 100vh;
}

a {
  color: inherit;
  text-decoration: none;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 0 var(--space-5);
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background 150ms ease, transform 150ms ease, box-shadow 150ms ease;
}

.btn--primary {
  background: var(--accent);
  color: white;
}

.btn--primary:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn--full {
  width: 100%;
}

.redirect-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-6);
  background: var(--bg-base);
}

.redirect-card {
  text-align: center;
  max-width: 420px;
  width: 100%;
  animation: slideUp 400ms ease;
}

.redirect-card__logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  margin-bottom: var(--space-8);
  font-size: var(--text-lg);
  font-weight: 600;
  color: var(--text-primary);
}

.redirect-card__logo img {
  width: 28px;
  height: 28px;
}

.redirect-card__title {
  font-size: var(--text-xl);
  font-weight: 600;
  margin: 0 0 var(--space-2);
}

.redirect-card__subtitle {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  margin: 0 0 var(--space-6);
}

.redirect-card__destination {
  font-family: var(--font-mono);
  font-size: var(--text-sm);
  color: var(--accent-hover);
  margin-bottom: var(--space-6);
  word-break: break-all;
}

.progress-bar {
  height: 4px;
  background: var(--bg-subtle);
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: var(--space-4);
}

.progress-bar__fill {
  height: 100%;
  background: var(--accent);
  transition: width 1s linear;
}

.redirect-card__countdown {
  font-size: var(--text-sm);
  color: var(--text-muted);
  margin-bottom: var(--space-6);
}

.redirect-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4);
}

.redirect-loading__text {
  color: var(--text-secondary);
  font-size: var(--text-sm);
  margin: 0;
}

.redirect-loading__spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--border-default);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .redirect-card,
  .redirect-loading__spinner {
    animation: none;
  }

  .progress-bar__fill {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/redirect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;;EAEzB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,iBAAiB;EACjB,uBAAuB;;EAEvB,0CAA0C;;EAE1C,6DAA6D;EAC7D,sDAAsD;;EAEtD,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;;EAElB,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,8EAA8E;AAChF;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[":root {\n  --bg-base: #09090B;\n  --bg-subtle: #27272A;\n  --border-default: #3F3F46;\n\n  --text-primary: #FAFAFA;\n  --text-secondary: #A1A1AA;\n  --text-muted: #71717A;\n\n  --accent: #6366F1;\n  --accent-hover: #818CF8;\n\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.5);\n\n  --font-display: 'Inter', system-ui, -apple-system, sans-serif;\n  --font-mono: 'JetBrains Mono', ui-monospace, monospace;\n\n  --text-sm: 0.875rem;\n  --text-base: 1rem;\n  --text-lg: 1.125rem;\n  --text-xl: 1.25rem;\n\n  --space-2: 8px;\n  --space-4: 16px;\n  --space-5: 20px;\n  --space-6: 24px;\n  --space-8: 32px;\n\n  --radius-md: 8px;\n}\n\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-display);\n  font-size: var(--text-base);\n  color: var(--text-primary);\n  background: var(--bg-base);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: 1.5;\n}\n\n#root {\n  min-height: 100vh;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 44px;\n  padding: 0 var(--space-5);\n  border-radius: var(--radius-md);\n  font-size: var(--text-sm);\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: background 150ms ease, transform 150ms ease, box-shadow 150ms ease;\n}\n\n.btn--primary {\n  background: var(--accent);\n  color: white;\n}\n\n.btn--primary:hover {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn--full {\n  width: 100%;\n}\n\n.redirect-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-6);\n  background: var(--bg-base);\n}\n\n.redirect-card {\n  text-align: center;\n  max-width: 420px;\n  width: 100%;\n  animation: slideUp 400ms ease;\n}\n\n.redirect-card__logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  margin-bottom: var(--space-8);\n  font-size: var(--text-lg);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.redirect-card__logo img {\n  width: 28px;\n  height: 28px;\n}\n\n.redirect-card__title {\n  font-size: var(--text-xl);\n  font-weight: 600;\n  margin: 0 0 var(--space-2);\n}\n\n.redirect-card__subtitle {\n  font-size: var(--text-sm);\n  color: var(--text-secondary);\n  margin: 0 0 var(--space-6);\n}\n\n.redirect-card__destination {\n  font-family: var(--font-mono);\n  font-size: var(--text-sm);\n  color: var(--accent-hover);\n  margin-bottom: var(--space-6);\n  word-break: break-all;\n}\n\n.progress-bar {\n  height: 4px;\n  background: var(--bg-subtle);\n  border-radius: 2px;\n  overflow: hidden;\n  margin-bottom: var(--space-4);\n}\n\n.progress-bar__fill {\n  height: 100%;\n  background: var(--accent);\n  transition: width 1s linear;\n}\n\n.redirect-card__countdown {\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  margin-bottom: var(--space-6);\n}\n\n.redirect-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-4);\n}\n\n.redirect-loading__text {\n  color: var(--text-secondary);\n  font-size: var(--text-sm);\n  margin: 0;\n}\n\n.redirect-loading__spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--border-default);\n  border-top-color: var(--accent);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(12px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .redirect-card,\n  .redirect-loading__spinner {\n    animation: none;\n  }\n\n  .progress-bar__fill {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
